// Alguns emissores paraguaios (ex.: SOS TECNOLOGIA Y GESTION DE INFORMACION LTDA)
// não têm a cadeia reconhecida pela RestPKI, então result.isValid vem false mesmo
// com o certificado sendo legítimo. Como aqui o certificado só serve para obter o
// RUC no login, aceitamos isValid=false quando o backend indica que o único
// problema é esse (acceptableForLogin) e o certificado ainda está dentro da
// validade.
export function certificadoParaguaiAceito(result) {
  if (result?.isValid) return true;
  if (result?.acceptableForLogin !== true) return false;

  const validityEnd = result?.certificate?.validityEnd;
  if (!validityEnd) return false;

  const fim = new Date(validityEnd);
  return !Number.isNaN(fim.getTime()) && fim.getTime() > Date.now();
}

// Retorna o documento usado no login do Paraguai: o RUC, ou o CI/CIE como reserva.
//
// O RUC da empresa fica no Subject Alternative Name (Endereço do Diretório) do
// certificado, não no Subject DN. Nem o Web-PKI nem a RestPKI expõem esse campo,
// então, se não vier pronto, lemos o certificado bruto (DER) e extraímos o
// serialNumber "RUC..." de dentro do SAN.
export async function obterDocumentoParaguai({ result, certificates, thumbprint, webPkiService }) {
  const selectedCert = certificates.find((c) => c.thumbprint === thumbprint);
  const py = selectedCert?.pkiParaguay || {};

  let rucBruto = py.ruc || result.certificate.ruc || "";
  if (!rucBruto) {
    rucBruto = (await webPkiService.readParaguayRuc(thumbprint)) || "";
  }
  // Ex.: "RUC80168836-1" -> "80168836-1"
  const ruc = rucBruto.replace(/^RUC/i, "").trim();

  if (ruc) return ruc;
  return (
    py.ci || result.certificate.ci || py.cie || result.certificate.cie || ""
  );
}
